export const InRange = (min, max, number) =>
{ 
  if(number >= min && number <= max)
  {
    return true;
  }
  else
  {
    return false;
  }
}

export const NearClosed = (max, number) =>
{ 
  //se si está por cerrar
  if(number >= max - 60 && number <= max)
  {
    return true;
  }
  else
  {
    return false;
  }
}